import axios from "axios";
import { url } from "../../constants/config";

export const showToastMessage = message => {
  return {
    type: "SHOW_TOAST_MESSAGE",
    payload: message
  };
};

export const showEditResult = (show, matchId) => {
  return {
    type: "SHOW_EDIT_RESULT",
    payload: {
      show,
      matchId
    }
  };
};

export const showPasswordDialog = (show, matchId, action) => {
  return {
    type: "SHOW_PASSWORD_DIALOG",
    payload: {
      show,
      matchId,
      action
    }
  };
};

export const postEditResult = (matchId, result) => {
  return {
    type: "POST_EDIT_RESULT",
    meta: {
      matchId
    },
    payload: axios.get(url + "post_result.php", {
      params: {
        matchId,
        result
      }
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/ui/uiActions.js